// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__crjMO","info":"Note_info__23mNh","note":"Note_note__3Jkty","actions":"Note_actions__2MNYn"};